module.exports = __webpack_public_path__ + "img/contact_01.e1343ce7.png";